import * as React from 'react';
import UserEstimationModel from '../../domain/UserEstimation';
import '../UserTableRow.css';
import { Link } from 'react-router-dom';
import formatNumber, { formatPrice } from '../formatNumber';

interface Props {
    userEstimations: UserEstimationModel;
    customerId: string;
    link: (orderId: number) => string;
}

export default class UserEstimation extends React.PureComponent<Props> {
    public render(): JSX.Element {
        return (
            <div className="user-table-details-row">
                <div>
                    <Link to={this.props.link(this.props.userEstimations.estimationId)}>{this.props.userEstimations.estimationId}</Link>
                </div>
                <div>
                    <span>{this.props.userEstimations.estimationDate}</span>
                </div>
                <div>
                    <span>{formatNumber(this.props.userEstimations.quantity, 0)}</span>
                </div>
                <div>
                    <span>{formatPrice(this.props.userEstimations.total)}</span>
                </div>
                <div>
                    <span>{this.props.userEstimations.deliveryDrop.year + '/' + this.props.userEstimations.deliveryDrop.month}</span>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/view/estimations/UserEstimation.tsx